<template>
    <Dialog :value="value" @input="$listeners.input" :title="'VINCULAR CONTRATO'" width="350" :show-close-button="true">
        <m-form ref="form" class="pt-4" @submit.prevent="vincular">
            <m-text-field ref="input"
                          label="Informe o novo ID:"
                          id="FieldVincularContrato"
                          class="required"
                          type="text"
                          v-model="hash_contrato_novo"
                          :rules="[$rules.required]"
                          maxlength="40"
                          outlined>
            </m-text-field>
        </m-form>
        <v-layout slot="buttons">
            <v-flex>
                <v-btn class="btn-default" color="primary" @click="vincular">Confirmar</v-btn>
            </v-flex>
        </v-layout>
    </Dialog>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    name: 'DialogVincularContrato',
    props: {
      hashContratoAntigo: String,
      idPedido: Number,
      value: Boolean
    },
    data: () => ({
      hash_contrato_novo: '',
      pass_visible: false
    }),
    watch: {
      value (open) {

      }
    },
    methods: {
      fechar () {
        this.value = false
      },
      async vincular () {
        const form = this.$refs.form
        if (form.validate()) {
          await this.$http.post('/painel/contrato/vincular_contrato', { hash_contrato_novo: this.hash_contrato_novo, hash_contrato_antigo: this.hashContratoAntigo, id_pedido: this.idPedido }).then(
            res => {
              if (res.data.success) {
                notification(AlertTypes.INFO, 'Novo contrato vinculado com sucesso!')
                this.reload()
              } else {
                if (res.data.msg !== '') {
                  notification(AlertTypes.WARN, res.data.msg)
                } else {
                  notification('info', 'Contrato ' + this.hash_contrato_novo + ' informado processando. Tente novamente.')
                }
              }
            }
          )
            .catch((err) => notification('error', err, 'Não foi possível vincular o contrato!'))
        }
      },
      reload () {
        this.$emit('reloadDataTable')
        this.$emit('input', false)
        return true
      }
    }
  }
</script>

<style scoped>

</style>
